import { ChevronRightIcon } from '@heroicons/react/24/outline';

export function Breadcrumb({ path = [], className = '' }) {
  if (path.length === 0) return null;

  return (
    <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
      {path.map((item, index) => (
        <div key={index} className="flex items-center space-x-2">
          {index > 0 && (
            <ChevronRightIcon className="h-4 w-4 text-text-secondary-light dark:text-text-secondary" />
          )}
          {item.active ? (
            <span className="font-semibold text-text-primary-light dark:text-text-primary">
              {item.label}
            </span>
          ) : (
            <button
              onClick={item.onClick}
              className="text-text-secondary-light dark:text-text-secondary hover:opacity-70 transition"
            >
              {item.label}
            </button>
          )}
        </div>
      ))}
    </nav>
  );
}
